export const filterWithoutComma = (options, { inputValue }) => {
    if (!inputValue) return options;

    const searchWords = inputValue.toLowerCase().trim().split(/\s+/).filter(Boolean);

    if (!searchWords.length) return options;

    return options.filter((option) => {
        const name = (option?.name || '').toLowerCase().trim();
        return searchWords.every((word) => name.includes(word));
    });
};
